const Domain = Object.freeze({
  FACEBOOK: 'facebook.com',
  TWITTER: 'twitter.com',
  YOUTUBE: 'youtube.com',
  INSTAGRAM: 'instagram.com',
  WEIBO: 'weibo.com',
  REDDIT: 'reddit.com',
  MSN: 'msn.com',
  TIKTOK: 'tiktok.com',
  BLUESKY: 'bsky.app',
  UNKNOWN: '',
  ALL: 'all'
})
export default Domain
export type DomainStrings = typeof Domain[keyof typeof Domain]
// RESERVE BELOW
